// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file guest/v1/nps.proto (package guest.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guest/v1/nps.proto.
 */
export const file_guest_v1_nps: GenFile = /*@__PURE__*/
  fileDesc("ChJndWVzdC92MS9ucHMucHJvdG8SCGd1ZXN0LnYxIhYKFEdldE5QU0NvbnRleHRSZXF1ZXN0IlgKFUdldE5QU0NvbnRleHRSZXNwb25zZRItCgtyZXNlcnZhdGlvbhgBIAEoCzIYLmd1ZXN0LnYxLk5QU1Jlc2VydmF0aW9uEhAKCGFuc3dlcmVkGAIgASgIIn4KDk5QU1Jlc2VydmF0aW9uEhcKD2d1ZXN0X2xhc3RfbmFtZRgBIAEoCRIYChBndWVzdF9maXJzdF9uYW1lGAIgASgJEhEKCXNob3BfbmFtZRgDIAEoCRISCgp2aXNpdF9kYXRlGAQgASgJEhIKCnZpc2l0X3RpbWUYBSABKAkiOQoWU3VibWl0TlBTQW5zd2VyUmVxdWVzdBIOCgZyYXRpbmcYASABKAUSDwoHY29tbWVudBgCIAEoCSIZChdTdWJtaXROUFNBbnN3ZXJSZXNwb25zZTK2AQoKTlBTU2VydmljZRJQCg1HZXROUFNDb250ZXh0Eh4uZ3Vlc3QudjEuR2V0TlBTQ29udGV4dFJlcXVlc3QaHy5ndWVzdC52MS5HZXROUFNDb250ZXh0UmVzcG9uc2USVgoPU3VibWl0TlBTQW5zd2VyEiAuZ3Vlc3QudjEuU3VibWl0TlBTQW5zd2VyUmVxdWVzdBohLmd1ZXN0LnYxLlN1Ym1pdE5QU0Fuc3dlclJlc3BvbnNlQkdaRWdpdGh1Yi5jb20vZWJpc29sL3ZpYWplcm8vYmFja2VuZC9pbnRlcm5hbC9nZW4vcHJvdG8vZ3Vlc3QvdjE7Z3Vlc3R2MWIGcHJvdG8z");

/**
 * @generated from message guest.v1.GetNPSContextRequest
 */
export type GetNPSContextRequest = Message<"guest.v1.GetNPSContextRequest"> & {
};

/**
 * Describes the message guest.v1.GetNPSContextRequest.
 * Use `create(GetNPSContextRequestSchema)` to create a new message.
 */
export const GetNPSContextRequestSchema: GenMessage<GetNPSContextRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_nps, 0);

/**
 * @generated from message guest.v1.GetNPSContextResponse
 */
export type GetNPSContextResponse = Message<"guest.v1.GetNPSContextResponse"> & {
  /**
   * アンケート対象の予約情報 (read_model.reservation 由来)。
   *
   * @generated from field: guest.v1.NPSReservation reservation = 1;
   */
  reservation?: NPSReservation | undefined;

  /**
   * 回答済みかどうか (crud.nps.answered_at の有無)。true の場合 SPA は
   * 回答済み画面を表示し、SubmitNPSAnswer は呼ばない。
   *
   * @generated from field: bool answered = 2;
   */
  answered: boolean;
};

/**
 * Describes the message guest.v1.GetNPSContextResponse.
 * Use `create(GetNPSContextResponseSchema)` to create a new message.
 */
export const GetNPSContextResponseSchema: GenMessage<GetNPSContextResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_nps, 1);

/**
 * NPSReservation はアンケート画面に表示する予約情報
 * (すべて予約時点のスナップショット。read_model.reservation 由来)。
 *
 * @generated from message guest.v1.NPSReservation
 */
export type NPSReservation = Message<"guest.v1.NPSReservation"> & {
  /**
   * ゲストの姓 (未入力は空文字)。
   *
   * @generated from field: string guest_last_name = 1;
   */
  guestLastName: string;

  /**
   * ゲストの名 (未入力は空文字)。
   *
   * @generated from field: string guest_first_name = 2;
   */
  guestFirstName: string;

  /**
   * 店舗名 (予約時点のスナップショット)。
   *
   * @generated from field: string shop_name = 3;
   */
  shopName: string;

  /**
   * 来店日 (JST。例: "2026-05-19")。
   *
   * @generated from field: string visit_date = 4;
   */
  visitDate: string;

  /**
   * 来店時間 (JST。例: "19:00")。
   *
   * @generated from field: string visit_time = 5;
   */
  visitTime: string;
};

/**
 * Describes the message guest.v1.NPSReservation.
 * Use `create(NPSReservationSchema)` to create a new message.
 */
export const NPSReservationSchema: GenMessage<NPSReservation> = /*@__PURE__*/
  messageDesc(file_guest_v1_nps, 2);

/**
 * @generated from message guest.v1.SubmitNPSAnswerRequest
 */
export type SubmitNPSAnswerRequest = Message<"guest.v1.SubmitNPSAnswerRequest"> & {
  /**
   * 星の数 (1〜5。必須)。範囲外は InvalidArgument。
   *
   * @generated from field: int32 rating = 1;
   */
  rating: number;

  /**
   * 自由記入欄 (任意。未記入は空文字)。
   *
   * @generated from field: string comment = 2;
   */
  comment: string;
};

/**
 * Describes the message guest.v1.SubmitNPSAnswerRequest.
 * Use `create(SubmitNPSAnswerRequestSchema)` to create a new message.
 */
export const SubmitNPSAnswerRequestSchema: GenMessage<SubmitNPSAnswerRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_nps, 3);

/**
 * @generated from message guest.v1.SubmitNPSAnswerResponse
 */
export type SubmitNPSAnswerResponse = Message<"guest.v1.SubmitNPSAnswerResponse"> & {
};

/**
 * Describes the message guest.v1.SubmitNPSAnswerResponse.
 * Use `create(SubmitNPSAnswerResponseSchema)` to create a new message.
 */
export const SubmitNPSAnswerResponseSchema: GenMessage<SubmitNPSAnswerResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_nps, 4);

/**
 * NPSService は来店後のアンケート (NPS) ページを提供する
 * (ゲスト予約・決済_詳細設計 §6.7)。来店確定バッチが visited へ遷移させた予約に対して
 * 送るアンケート依頼メール (バッチ処理_詳細設計 §4.5) の URL
 * ({GUEST_BASE_URL}/nps/{npsToken}) から開かれる。
 *
 * 認証は Cognito を通さず、URL 由来の npsToken を x-nps-token ヘッダで受け取り、
 * Guest 公開 Interceptor がハッシュ照合して crud.nps の行と予約・テナントを解決する
 * (ADR-011)。case-token / reservation-token と並ぶ 3 系統目のトークンで、
 * リクエストに npsToken パラメータは持たない。
 * トークン無し・不一致は NotFound、期限切れ (発行 + 7 日) は FailedPrecondition。
 *
 * @generated from service guest.v1.NPSService
 */
export const NPSService: GenService<{
  /**
   * GetNPSContext はアンケート画面の表示に必要な予約情報を返す (§6.7)。
   * 応答はすべて x-nps-token で解決した予約由来のため、リクエストにパラメータは持たない。
   *
   * @generated from rpc guest.v1.NPSService.GetNPSContext
   */
  getNPSContext: {
    methodKind: "unary";
    input: typeof GetNPSContextRequestSchema;
    output: typeof GetNPSContextResponseSchema;
  },
  /**
   * SubmitNPSAnswer はアンケートの回答 (星の数・自由記入欄) を保存する (§6.7)。
   * 1 予約 = 1 回答で、回答済みのトークンでの再回答は FailedPrecondition を返す
   * (SPA は GetNPSContext の answered で回答済み画面を出し分ける)。
   *
   * @generated from rpc guest.v1.NPSService.SubmitNPSAnswer
   */
  submitNPSAnswer: {
    methodKind: "unary";
    input: typeof SubmitNPSAnswerRequestSchema;
    output: typeof SubmitNPSAnswerResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guest_v1_nps, 0);

